// Tiny cross-scene helpers.

/** Hash a string to a stable non-negative 32-bit int. */
export function hashString(s: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Short hex color from a numeric triple. */
export function hexColor(n: number): string {
  return `#${n.toString(16).padStart(6, '0')}`;
}

/** Deterministic 16-color palette for avatar backgrounds, designed to contrast white text. */
export const AVATAR_PALETTE: readonly string[] = [
  '#E23E3E',
  '#E2813E',
  '#D6B32C',
  '#7ABD1F',
  '#2EB85C',
  '#2AB3AA',
  '#2A77D4',
  '#5F3ED6',
  '#A03ED6',
  '#D63E9F',
  '#D6506B',
  '#8F5A26',
  '#6B7A3E',
  '#3E7A8C',
  '#4C4C7E',
  '#7B3E6B',
];

export function paletteFor(seed: string): string {
  const i = hashString(seed) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[i] ?? '#2A77D4';
}
